<template>
  <div class="bg-white py-24 sm:py-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="grid grid-cols-1 gap-x-8 gap-y-16">

        <div class="sm:align-center sm:flex sm:flex-col mb-5">
          <h1 class="text-5xl font-bold tracking-tight text-gray-900 sm:text-center">{{ __('Explore our other features') }}</h1>
          <p class="mt-5 text-xl text-gray-500 sm:text-center">{{ __('LIVCK is designed to benefit customers and employees alike with its multiple features. It optimizes workflow and leads to a reduction in the number of support tickets.') }}</p>
<!--          <div class="relative mt-6 flex self-center rounded-lg bg-gray-100 p-0.5 sm:mt-8">-->
<!--            <button @click="billing_cycle = '30 days'" type="button" class="relative w-1/2 whitespace-nowrap rounded-md py-2 text-sm font-medium shadow-sm focus:z-10 focus:outline-none focus:ring-0 sm:w-auto sm:px-8" :class="{'border-gray-200 text-gray-900 bg-white': billing_cycle === '30 days', 'border-transparent text-gray-700': billing_cycle === '365 days'}">{{ __('Monthly billing') }}</button>-->
<!--            <button @click="billing_cycle = '365 days'" type="button" class="relative ml-0.5 w-1/2 whitespace-nowrap rounded-md border py-2 text-sm font-medium focus:z-10 focus:outline-none focus:ring-0 sm:w-auto sm:px-8" :class="{'border-gray-200 text-gray-900 bg-white': billing_cycle === '365 days', 'border-transparent text-gray-700': billing_cycle === '30 days'}">{{ __('Yearly billing') }}</button>-->
<!--          </div>-->
        </div>

        <div class="mx-auto w-full max-w-xl items-center lg:mx-0 lg:max-w-none border border-gray-100 rounded-md">
          <div class="grid gap-8 bg-white p-7 lg:grid-cols-3">
            <a
                v-motion
                :initial="{ y: -100, opacity: 0 }"
                :enter="{ y: 0, opacity: 1 }"
                :delay="(iX+1)*5"
                v-for="(item, iX) in productFeatures"
                :key="item.name"
                :href="item.href"
                class="-m-3 flex items-center rounded-lg p-2 transition duration-150 ease-in-out hover:bg-gray-50 focus:outline-none focus-visible:ring focus-visible:ring-primary-500 focus-visible:ring-opacity-50"
            >
              <div
                  class="flex h-10 w-10 shrink-0 items-center justify-center text-white sm:h-12 sm:w-12 bg-primary-500/10 text-primary-500 rounded-md p-2.5"
              >
                <component :is="item.icon" aria-hidden="true"/>
              </div>
              <div class="ml-4">
                <p class="text-sm font-medium text-gray-900">
                  {{ __(item.name) }}
                </p>
                <p class="text-sm text-gray-500">
                  {{ __(item.description) }}
                </p>
              </div>
            </a>
          </div>
<!--          <div v-for="feature in productFeatures" class="flex items-center space-x-4 hover:bg-gray-100 transition-all duration-300 rounded-md px-4 py-6 cursor-pointer">-->
<!--            <component :is="feature.icon" class="h-12 w-12 text-primary-500" aria-hidden="true" />-->
<!--            <div>-->
<!--              <h3 class="text-lg font-medium text-gray-900">{{ __(feature.name) }}</h3>-->
<!--              <p class="mt-2 text-base text-gray-500">{{ __(feature.description) }}</p>-->
<!--            </div>-->
<!--          </div>-->
        </div>
        <div class="mt-8 flex justify-center">
          <p class="relative rounded-full bg-gray-100 px-4 py-1.5 text-sm leading-6 text-gray-900">
            <span class="hidden md:inline">{{ __('Do you have an idea for a feature we should include in LIVCK?') }}</span>
            <a href="mailto:support@livck.com" class="font-semibold text-black"><span class="absolute inset-0" aria-hidden="true" /> {{ __('Contact Us') }} <span aria-hidden="true">&rarr;</span></a>
          </p>
        </div>
<!--        <div class="mt-8 flex items-center gap-x-6">-->
<!--          <a href="#" class="rounded-md bg-primary-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600">Create account</a>-->
<!--          <a href="#" class="text-sm font-semibold text-gray-900">Contact us <span aria-hidden="true">&rarr;</span></a>-->
<!--        </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import productFeatures from "@/data/productFeatures";

export default {
  name: "FeaturePreviewBox",
  setup() {
    return {productFeatures};
  }
}
</script>